import { Navigate, Outlet } from "react-router-dom";
import useAuth from "../hooks/useAuth";
import { useEffect, useState } from "react";
import useRefresh from "../hooks/useRefresh";

function RequiredAuth() {
	const { auth, setAuth } = useAuth();
	const refresh = useRefresh();
	const [activeToken, setActiveToken] = useState(null);
	const [isLoading, setIsLoading] = useState(true); // optional, for handling loading state

	useEffect(() => {
		const fetchAccessToken = async () => {
			// If token is missing or undefined, try to refresh
			if (!auth?.accessToken) {
				try {
					const newAccessToken = await refresh();
					if (newAccessToken) {
						setActiveToken(newAccessToken);
						// Optionally update global auth state
						setAuth((prev) => ({
							...prev,
							accessToken: newAccessToken,
						}));
					} else {
						// No token received, treat as unauthenticated
						setActiveToken(null);
					}
				} catch (error) {
					console.error("Token refresh failed:", error);
					setActiveToken(null);
				}
			} else {
				// Token exists
				setActiveToken(auth.accessToken);
			}
			setIsLoading(false);
		};

		fetchAccessToken();
	}, [auth?.accessToken, refresh, setAuth]);

	if (isLoading) {
		// Optional: Show loading spinner or null
		// return null; // or a loader
		return <p>loading....</p>;
	}

	if (!activeToken) {
		// No token after refresh attempt, redirect to login
		return <Navigate to="/" replace />;
	}

	// Token exists, render child routes
	return <Outlet />;
}

export default RequiredAuth;
